export const EntityId = {
  SUNPHARMA: 1039375,
  SUNPHARMA_OPD_DEMO: 11310642,
  WIPRO_PROD: 1006778,
  WIPRO_STAGING: 11189525,
  WIPRO_TESTING: 11186752,
  WIPRO_DEMO: 11317947,
  NESTLE_DEMO: 11197446,
  NESTLE_INDIA: 11174925,
  NESTLE_BUSINESS: 11237250,
};

export const WIPRO_ENTITY_ID_LIST = [
  EntityId.WIPRO_PROD,
  EntityId.WIPRO_STAGING,
  EntityId.WIPRO_TESTING,
  EntityId.WIPRO_DEMO,
];

export const NESTLE_ENTITY_ID_LIST = [
  EntityId.NESTLE_DEMO,
  EntityId.NESTLE_INDIA,
  EntityId.NESTLE_BUSINESS,
];

export const EntityIdBasedCustomConfig = {
  rawFileUploadEntityId: [EntityId.SUNPHARMA],
  multipleBillUploadEntityId: [
    EntityId.SUNPHARMA,
    EntityId.SUNPHARMA_OPD_DEMO,
    EntityId.WIPRO_PROD,
    EntityId.WIPRO_STAGING,
    EntityId.WIPRO_TESTING,
    EntityId.WIPRO_DEMO,
  ],
};

export const SNOWPLOW_EVENTS_SCHEMA = {
  HOME_SCREEN_REIM_CLICK:
    "iglu:com.medibuddy/HOME_SCREEN_REIM_CLICK/jsonschema/2-0-0",
  MB_REIM_HOMEPAGE_LANDED:
    "iglu:com.medibuddy/MB_REIM_HOMEPAGE_LANDED/jsonschema/2-0-0",
  MB_REIM_CREATE_CLAIM:
    "iglu:com.medibuddy/MB_REIM_CREATE_CLAIM/jsonschema/2-0-0",
  MB_REIM_USER_DETAILS_NEXT:
    "iglu:com.medibuddy/MB_REIM_USER_DETAILS_NEXT/jsonschema/2-0-0",
  MB_REIM_SAVE_BILL: "iglu:com.medibuddy/MB_REIM_SAVE_BILL/jsonschema/2-0-0",
  MB_REIM_SUBMIT_CLAIM:
    "iglu:com.medibuddy/MB_REIM_SUBMIT_CLAIM/jsonschema/2-0-0",
  MB_REIM_UPLOAD_BILL_CLICK:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_BILL_CLICK/jsonschema/2-0-0",
  MB_REIM_UPLOAD_RX_CLICK:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_RX_CLICK/jsonschema/2-0-0",
  MB_REIM_UPLOAD_REPORT_CLICK:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_REPORT_CLICK/jsonschema/2-0-0",
  MB_REIM_UPLOAD_BILL_SUCCESS:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_BILL_SUCCESS/jsonschema/2-0-0",
  MB_REIM_UPLOAD_RX_SUCCESS:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_RX_SUCCESS/jsonschema/2-0-0",
  MB_REIM_UPLOAD_REPORT_SUCCESS:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_REPORT_SUCCESS/jsonschema/2-0-0",
  MB_REIM_YOUR_CLAIMS_CLICK:
    "iglu:com.medibuddy/MB_REIM_YOUR_CLAIMS_CLICK/jsonschema/2-0-0",
  MB_REIM_HOME_BANNER:
    "iglu:com.medibuddy/MB_REIM_HOME_BANNER/jsonschema/2-0-0",
  MB_REIM_CLAIM_BANNER:
    "iglu:com.medibuddy/MB_REIM_CLAIM_BANNER/jsonschema/2-0-0",
  MB_REIM_UPLOAD_BILL_FAIL:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_BILL_FAIL/jsonschema/2-0-0",
  MB_REIM_UPLOAD_RX_FAIL:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_RX_FAIL/jsonschema/2-0-0",
  MB_REIM_UPLOAD_REPORT_FAIL:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_REPORT_FAIL/jsonschema/2-0-0",
  REIMBURSEMENT_RESUBMIT_BILL_SAVE_CLICKS:
    "iglu:com.medibuddy/Reimbursement_Resubmit_Bill_Save_Clicks/jsonschema/1-0-0",
  REIMBURSEMENT_RESUBMIT_CLAIM_SAVE_CLICKS:
    "iglu:com.medibuddy/Reimbursement_Resubmit_Claim_Save_Clicks/jsonschema/1-0-0",
};

export const OPDConfig = {
  Old_Policy_EntityPolicyId: 1,
  Old_Policy_SubscriptionId: 1,
};

export const DocumentType = Object.freeze({
  BILL_INVOICE: "Bill_Invoice",
  PRESCRIPTION: "Prescription",
  LAB_REPORT: "LabReport",
});

export const HIDE_BENEFITS_SECTIONS_ENTITY_ID_LIST = [
  11333572
];
export const PRESCRIPTION_QUESTION_ENTITY_ID_LIST = [
  EntityId.NESTLE_DEMO,
  EntityId.NESTLE_INDIA,
  EntityId.NESTLE_BUSINESS,
];

export const ScreenName = {
  HOMEPAGE: "Reimbursement Home Page",
  CREATE_CLAIM: "Create Claim page",
  USER_DETAILS_NEXT: "User Details Next page",
  SUMMARY: "Reimbursement Summary page",
  YOUR_CLAIMS: "Your Claims page",
  INFORMATION_REQUIRED: "Information Required page",
}